import React from "react";
import * as R from "ramda";

export const unlessChild = (fn: () => void) =>
  R.unless(
    (e: React.FocusEvent<HTMLDivElement>) =>
      e.target.contains((e as any).relatedTarget),
    fn
  );
